export const emailRegexp = /^[a-zA-Z0-9]+[\w.!#$%&'*+=?^_`{|}~-]*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const emailRegexpRequireDot = /^[a-zA-Z0-9]+[\w.!#$%&'*+=?^_`{|}~-]*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
